import * as React from 'react';

import { type TContext } from '../types/context';

import { context } from './context';

export function useContext(): TContext {
  return React.useContext(context);
}
